import { PUBLIC_LAYOUT, PUBLIC_MENU_LAYOUT } from '@/constants/layouts'
import { FOOTER_COMPONENT_NAMES } from '@/components/public/footers/index'
import { OPENSALUD360_PLATFORM_NAME } from '@/constants/platformNames'

const layout = PUBLIC_LAYOUT
const footer = {
  component: FOOTER_COMPONENT_NAMES.OPENSALUD
}

const i18nFile = 'public/views/opensalud4all'

export default [
  {
    path: '/',
    name: 'opensalud4all',
    component: () => import('@/components/views/opensalud/Opensalud4all'),
    meta: {
      title: {
        text: 'opensalud4all'
      },
      layout,
      footer,
      i18n: 'public/views/opensalud4all',
      gtag: OPENSALUD360_PLATFORM_NAME
    }
  },
  {
    path: 'contact/success',
    name: 'ContactFormSuccessOpensalud4All',
    component: () => import('@/components/views/CompaniesContactFormSuccess'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT,
      i18n: 'forms/companies-contact-form.json'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes/opensalud4all.routes.js